/**
 * Dinheiro em Lira = SEMPRE inteiros em centavos. Formatação só aqui, no render.
 * Ver CLAUDE.md § Dinheiro.
 */

const BRL = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

/** 123456 -> "R$ 1.234,56" */
export function formatBRL(cents: number): string {
  return BRL.format(cents / 100);
}

/** 123456 -> "1.234,56" (sem símbolo, p/ campos/CSV) */
export function formatAmount(cents: number): string {
  return (cents / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Converte reais (número ou string "1.234,56" / "1234.56") para centavos inteiros,
 * sem erro de ponto flutuante. Retorna null se inválido.
 */
export function toCents(input: number | string): number | null {
  if (typeof input === 'number') {
    if (!Number.isFinite(input)) return null;
    return Math.round(input * 100);
  }
  const cleaned = input.trim().replace(/\s|R\$/g, '');
  if (cleaned === '') return null;
  // normaliza pt-BR ("1.234,56") e en ("1,234.56"/"1234.56")
  let normalized: string;
  if (cleaned.includes(',') && cleaned.includes('.')) {
    // o último separador é o decimal
    normalized = cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')
      ? cleaned.replace(/\./g, '').replace(',', '.')
      : cleaned.replace(/,/g, '');
  } else if (cleaned.includes(',')) {
    normalized = cleaned.replace(',', '.');
  } else {
    normalized = cleaned;
  }
  const value = Number(normalized);
  if (!Number.isFinite(value)) return null;
  return Math.round(value * 100);
}

/** Centavos -> reais como número (use só para gráficos; nunca reintroduza em cálculo monetário). */
export function centsToReais(cents: number): number {
  return cents / 100;
}
